import { EventEmitter, Inject, Injectable, Output } from "@angular/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { BehaviorSubject } from "rxjs";
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class OktaWrapperService {

  private heldToken?: HeldToken;
  private currentUser?: ICurrentUser;
  public authenticationChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Output() loggedOut: EventEmitter<void> = new EventEmitter();

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
    console.log('OktaWrapperService');

    // Bind into the Okta token Manager to monitor token events

    const tokenManager = this.oktaAuth.tokenManager;
    tokenManager.on('added', (key: any, token: any) => {
      if (key == 'accessToken') {
        this.heldToken = { token: token.accessToken, expiresAt: new Date(token.expiresAt * 1000) };
        this.currentUser = jwtDecode(this.heldToken.token);
        console.log(this.currentUser);
        this.authenticationChanged.next(true);
      }
    });

    tokenManager.on('expired', (key: any, expiredToken: any) => {
      if (key == 'accessToken') {
        this.heldToken = undefined;
        this.currentUser = undefined;
        this.authenticationChanged.next(false);
      };
    });

    tokenManager.on('renewed', (key: any, oldToken: any, newToken: any) => {
      console.log('Token Renewed');
    });

    tokenManager.on('error', (err: any) => {
      console.log(err); 
    });
  }

  isAuthenticated(): boolean {
    if (!this.heldToken) {
      return false;
    }

    if (this.heldToken.expiresAt < new Date()) {
      return false;
    }

    return true;
  }

  getUser(): ICurrentUser | undefined {
    return this.currentUser;
  }

  getAccessToken(): string | undefined {
    if (this.heldToken) {
      return this.heldToken.token;
    }

    return undefined;
  }

  logout(): void {
    this.loggedOut.emit();
    this.oktaAuth.signOut();    
  }

}

interface HeldToken {
  token: string;
  expiresAt: Date;
}

export interface ICurrentUser {
  Groups: string[];
  aud: string;
  auth_time: number;
  cid: string;
  email: string;
  exp: number;
  firstName: string;
  iat: number;
  iss: string;
  jti: string;
  lastName: string;
  scp: string[];
  sub: string;
  uid: string;
  ver: number;
}
